import React from 'react';
import { StepProps } from '../MultiStepModal';

function QuoteDetailsStep({ data, onDataChange }: StepProps) {
  const handleInputChange = (field: string, value: string) => {
    onDataChange({ [field]: value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission is handled by parent component
  };

  return (
    <div className="step-form">
      <div className="step-header">
        <h3 className="step-form-title">Quote Details</h3>
        <p className="step-form-subtitle">Provide information about the quote you want to create</p>
      </div>

      <form onSubmit={handleSubmit} className="step-form-content">
        <div className="form-group">
          <label className="form-label">Quote Title *</label>
          <input
            type="text"
            className="form-input"
            placeholder="e.g., Boiler Installation Quote, Heating System Upgrade"
            value={data.title || ''}
            onChange={(e) => handleInputChange('title', e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label className="form-label">Service Type *</label>
          <select
            className="form-select"
            value={data.type || ''}
            onChange={(e) => handleInputChange('type', e.target.value)}
            required
          >
            <option value="">Select service type</option>
            <option value="boiler-installation">Boiler Installation</option>
            <option value="boiler-service">Boiler Service</option>
            <option value="gas-safety">Gas Safety Check</option>
            <option value="central-heating">Central Heating Installation</option>
            <option value="heating-repair">Heating System Repair</option>
            <option value="electrical">Electrical Work</option>
            <option value="plumbing">Plumbing Work</option>
            <option value="bathroom">Bathroom Installation</option>
            <option value="kitchen">Kitchen Installation</option>
            <option value="maintenance">Maintenance Contract</option>
          </select>
        </div>

        <div className="form-group">
          <label className="form-label">Description</label>
          <textarea
            className="form-textarea"
            placeholder="Describe the work to be quoted for..."
            value={data.description || ''}
            onChange={(e) => handleInputChange('description', e.target.value)}
            rows={3}
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Estimated Cost (£)</label>
            <input
              type="number"
              className="form-input"
              placeholder="0.00"
              value={data.estimatedCost || ''}
              onChange={(e) => handleInputChange('estimatedCost', e.target.value)}
              min="0"
              step="0.01"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Valid Until</label>
            <input
              type="date"
              className="form-input"
              value={data.validUntil || ''}
              onChange={(e) => handleInputChange('validUntil', e.target.value)}
              min={new Date().toISOString().split('T')[0]}
            />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Priority *</label>
          <div className="radio-group">
            {[
              { value: 'LOW', label: 'Low Priority', color: '#6B7280' },
              { value: 'MEDIUM', label: 'Medium Priority', color: '#3B82F6' },
              { value: 'HIGH', label: 'High Priority', color: '#EF4444' }
            ].map((priority) => (
              <label key={priority.value} className="radio-option">
                <input
                  type="radio"
                  name="priority"
                  value={priority.value}
                  checked={data.priority === priority.value}
                  onChange={(e) => handleInputChange('priority', e.target.value)}
                />
                <span className="radio-label" style={{ color: priority.color }}>
                  {priority.label}
                </span>
              </label>
            ))}
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Additional Notes</label>
          <textarea
            className="form-textarea"
            placeholder="Any special requirements, terms, or conditions..."
            value={data.notes || ''}
            onChange={(e) => handleInputChange('notes', e.target.value)}
            rows={2}
          />
        </div>
      </form>
    </div>
  );
}

export default QuoteDetailsStep;
